<template>
    <div>
        <mu-avatar icon="date_range"></mu-avatar>
        <label>日期选择器</label>
    </div>
</template>
<script>
export default {
    name: 'datePicker'
}
</script>



// WEBPACK FOOTER //
// datePicker.vue?19194a70